export const states = {
    app: "App_State",
    userInfo: "userInfo",
    profileInfo: "Profile_Info",
    allLocales: "allLocales",
    allWorkSpaces: "allworkspaces",
    changeWorkSpace: "changeWorkSpace"
}

export const stateEvents = {
    logouted: "logouted",
    signOut: "SignOut",
    globalError: "Global_Error_Occured",
    validateCheck: "ckeckValidate",
    selfBaner: "self_baner",
    setWorkSpace: "setWorkSpace",
    openModalPage: "openModalPage",
    scrollUp: "scrollUp",
    // a call answered 403 ORGANIZATION_MEMBERSHIP_REQUIRED / 503
    // ORGANIZATIONS_UNAVAILABLE (sessionService reacts)
    organizationMembershipLost: "organizationMembershipLost",
    organizationsUnavailable: "organizationsUnavailable"
}